import angular from 'angular';

const CDN_BASE = 'https://images.opendoor.com/source/s3/imgdrop-production';

module.exports = angular.module('common.filters.image-url', [])
.filter('imageUrl', function() {
  return function(fileAndParams) {
    if (!fileAndParams) return;
    const filename = fileAndParams.split('?')[0];
    return `${CDN_BASE}/${filename}?service=web`;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/image-url.js
 **/